import { Set } from 'immutable';
import { VideoEditorState } from './types';

export const DEFAULT_STATE: VideoEditorState = {
  loadingIds: Set<string>(),
  overlayOpen: false,
  selectedAsset: {
    id: undefined,
    dragging: false,
  },
};
